import React from 'react';

import {
	SelectedAccountProvider,
} from '~/contexts/SelectedAccountContext';
import useMenuExpandedState from '~/hooks/useMenuExpandedState';
import useViewportType from '~/hooks/useViewportType';
import {
	isPhase3,
} from '~/utilities/viewportSize';

import ScreenSidebarInner from './ScreenSidebarInner';



const ScreenSidebar: React.FC = () => {
	const viewportType = useViewportType();
	const [
		isMenuExpanded,
		setMenuExpanded,
		isMenuMinimized,
		setMenuMinimized,
	] = useMenuExpandedState();

	const isNaturallyPhase3 = isPhase3(viewportType);
	const prevIsNaturallyPhase3Ref = React.useRef<boolean | null>(null);

	// Auto-clear menu expansion/minimization when viewport naturally changes to Phase 3
	React.useEffect(() => {
		const wasPhase3 = prevIsNaturallyPhase3Ref.current;
		const isNowPhase3 = isNaturallyPhase3;

		if (wasPhase3 === null) {
			prevIsNaturallyPhase3Ref.current = isNowPhase3;
			return;
		}

		if (!wasPhase3 && isNowPhase3) {
			if (isMenuExpanded) {
				setMenuExpanded(false);
			}

			if (isMenuMinimized) {
				setMenuMinimized(false);
			}
		}

		prevIsNaturallyPhase3Ref.current = isNowPhase3;
	}, [
		isNaturallyPhase3,
		isMenuExpanded,
		setMenuExpanded,
		isMenuMinimized,
		setMenuMinimized,
	]);

	return (
		<SelectedAccountProvider>
			<ScreenSidebarInner />
		</SelectedAccountProvider>
	);
};



export default ScreenSidebar;
